(() => {
  const init = (root) => {
    const el = root.querySelector('[data-ovra-flavour-wheel]');
    if (!el) return;

    // Make sure Swiper is available
    if (!window.Swiper) return;

    const swiperEl = el.querySelector('.ovra-wheel-swiper');
    if (!swiperEl) return;

    const prev = el.querySelector('.ovra-wheel-prev');
    const next = el.querySelector('.ovra-wheel-next');

    const swiper = new Swiper(swiperEl, {

      slidesPerView: 1.45,
      centeredSlides: true,
      // Switched off loop mode. With only 4 real slides and up to 3
      // visible at once, Swiper's clone-duplication math for loop
      // mode is a known edge case — there's no reliable
      // loopAdditionalSlides value that doesn't either skip a
      // flavour or get stuck repeating one. rewind bounces back at
      // the ends instead of wrapping seamlessly, but it uses the 4
      // real slides only, so there's no index math to get wrong.
      loop: false,
      rewind: true,
      // Allow rapid nav clicks (especially iOS Safari)
      preventInteractionOnTransition: false,
      // Same speed on every platform on purpose, so the wheel feels
      // identical on iOS and Android rather than tuned per-device.
      speed: 420,
      grabCursor: true,
      spaceBetween: 22,
      effect: 'slide',
      // Make side slides tappable (brings them to center) and don't swallow clicks
      slideToClickedSlide: true,
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,
      
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      // Enable wheel only while hovering the wheel to avoid hijacking page scroll
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 0.6,
        thresholdDelta: 10,
        thresholdTime: 200,
      },
      breakpoints: {

    0: {

        slidesPerView: 1.15,

        spaceBetween: 14,

    },

    768: {

        slidesPerView: 2.2,

        spaceBetween: 18,

    },

    1100: {

        slidesPerView: 3,

        spaceBetween: 26,

    }

},
    });

    /* OVRA Touch Improvement */
      prev.style.touchAction = "manipulation";
      next.style.touchAction = "manipulation";
      swiper.update();

swiper.navigation.update();

      swiper.on("touchStart",()=>{

    document.body.classList.add("ovra-dragging");

});

swiper.on("touchEnd",()=>{

    document.body.classList.remove("ovra-dragging");

});

    // This is the main perf fix: cover the FULL real transition
    // (touch drag + the momentum/snap glide after release, and
    // clicks on the nav arrows), not just the touch window. Blur
    // is swapped for a flat colour via CSS for the whole duration,
    // and restored the instant the slide settles.
    swiper.on("transitionStart", () => {
      el.classList.add("ovra-wheel--in-motion");
    });

    swiper.on("transitionEnd", () => {
      el.classList.remove("ovra-wheel--in-motion");
    });



    // Wheel behaviour: only active while user is over the wheel
    try {
      swiper.mousewheel.disable();
      el.addEventListener('mouseenter', () => swiper.mousewheel.enable());
      el.addEventListener('mouseleave', () => swiper.mousewheel.disable());
      el.addEventListener('touchstart', () => swiper.mousewheel.disable(), { passive: true });
    } catch (e) {}

    // Ensure taps/clicks on action buttons don't get interpreted as a swipe/drag.
    // Use non-passive so we can preventDefault on touch devices.
    el.querySelectorAll('.ovra-wheel__actions button, .ovra-wheel__actions a').forEach((node) => {
      node.addEventListener('pointerdown', (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
      }, { passive: false });
      node.addEventListener('click', (ev) => ev.stopPropagation(), { passive: true });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init(document));

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
